module.exports = __webpack_public_path__ + "img/1602347345.7d1007be.png";